<template>
  <div v-if="datasource.length > 0" :style="divStyle">
    <v-expansion-panels v-model="expandedPanel" accordion>
      <v-expansion-panel v-for="(row, index) in datasource" :key="index">
        <v-expansion-panel-header
          v-bind:color="titleColorList[index] ? titleColorList[index].color : 'defaultColor'"
          @click="titleClick(index)"
        >
          <v-row no-gutters align="center">
            <v-col v-if="readonly" class cols="8">
              <div class="pb-1">{{ row.title }}</div>
              <span :style="mainStyle">{{ row.riskFactorContent }}</span>
            </v-col>
            <v-col v-else cols="8">
              <v-text-field v-if="row.__created__" :style="mainStyle" v-model="row.workNm" />
              <span v-else :style="mainStyle">{{ row.riskFactorContent }}</span>
            </v-col>
            <v-col v-if="!readonly" cols="4" class="d-flex justify-end" align="center">
              <span :style="mainStyle">이행 : {{ row.cnt ? row.cnt : 0 }} / 미이행 : {{ row.uncnt }}</span>
              <v-tooltip right color="primary" max-width="300px">
                <template v-slot:activator="{ on }">
                  <span>
                    <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                  </span>
                </template>
                <div class="tooltip-text">{{ '해당 항목은 저장 후 갱신됩니다.' }}</div>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- 작업공정 안전보건정보 작성 -->
          <v-card width="100%" class="mt-4 pa-4 panel-inner">
            <span class="editor-title">작업내용</span>
            <v-form ref="form">
              <!-- 평가일자 -->
              <v-row no-gutters>
                <v-col cols="3" class="pr-3">
                  <span class="editor-label">평가일자</span>
                  <v-text-field
                    :value="formatDate(row.doDt)"
                    readonly
                    hide-details
                    append-icon="mdi-calendar"
                    solo
                    class="editor_bg"
                    style="width: 100%;"
                  ></v-text-field>
                </v-col>
                <!-- 위험분류 -->
                <v-col cols="3" class="px-1">
                  <span class="editor-label">위험분류</span>
                  <v-text-field
                    v-model="row.riskFactorDivNm"
                    readonly
                    hide-details
                    solo
                    class="editor_bg"
                    style="width: 100%;"
                  ></v-text-field>
                </v-col>
                <!-- 사고발생시 피해예상자 -->

                <v-col cols="6" class="pl-3">
                  <span class="editor-label">사고발생시 피해예상자</span>
                  <div class="mt-2">
                    <v-tooltip bottom v-for="(i, indexVi) in row.victims" :key="indexVi">
                      <template v-slot:activator="{ on }">
                        <v-chip v-on="on" class="mr-2">
                          <v-icon left>mdi-account</v-icon>
                          {{ i.victimNm }}
                        </v-chip>
                      </template>
                      <div v-html="i.victimNm"></div>
                    </v-tooltip>
                  </div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mt-5">
                <v-col cols="12">
                  <span class="editor-label">유해위험요인 파악</span>
                  <v-text-field v-model="row.riskFactorContent" solo class="editor_bg" readonly></v-text-field>
                </v-col>
              </v-row>

              <!-- 위험성 평가 -->
              <v-row no-gutters class="mt-5">
                <v-col
                  v-if=" dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation]"
                  cols="12"
                >
                  <span
                    class="editor-label"
                  >위험성평가 (위험성평가 기법: {{ dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].minorNm }})</span>
                  <v-row no-gutters>
                    <v-col cols="6" class="pr-1">
                      <v-simple-table v-if="dataSetList[0].riskEstimation" class="custom-table">
                        <template
                          v-if="dataSetList[0].riskEstimation === '00002' && dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation]"
                        >
                          <tr class="text-center tableTitle">
                            <td colspan="3">현재위험성</td>
                          </tr>
                          <tr>
                            <td class="text-center tableTitle">{{ getHeaderValue('high') }}</td>
                            <td class="text-center tableTitle">{{ getHeaderValue('middle') }}</td>
                            <td class="text-center tableTitle">{{ getHeaderValue('lower') }}</td>
                          </tr>
                          <tr :key="tableComponentKey">
                            <td>
                              <v-radio-group
                                v-model="row.riskEstimationVal1"
                                row
                                style="display:flex; justify-content:center !important;"
                              >
                                <v-radio
                                  color="radio"
                                  v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[0].minorCd"
                                  style="margin-left: 16px !important;"
                                  disabled
                                ></v-radio>
                              </v-radio-group>
                            </td>
                            <td>
                              <v-radio-group
                                v-model="row.riskEstimationVal1"
                                row
                                style="display:flex; justify-content:center !important;"
                              >
                                <v-radio
                                  color="radio"
                                  v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[1].minorCd"
                                  style="margin-left: 16px !important;"
                                  disabled
                                ></v-radio>
                              </v-radio-group>
                            </td>
                            <td>
                              <v-radio-group
                                v-model="row.riskEstimationVal1"
                                row
                                style="display:flex; justify-content:center !important;"
                              >
                                <v-radio
                                  color="radio"
                                  v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[2].minorCd"
                                  style="margin-left: 16px !important;"
                                  disabled
                                ></v-radio>
                              </v-radio-group>
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr class="text-center tableTitle">
                            <td colspan="3">현재위험성</td>
                          </tr>
                          <tr>
                            <td class="text-center tableTitle required">빈도</td>
                            <td class="text-center tableTitle required">강도</td>
                            <td class="text-center tableTitle">위험성</td>
                          </tr>
                          <tr :key="tableComponentKey">
                            <td class="text-center">{{ row.riskEstimationNum1 }}</td>
                            <td class="text-center">{{ row.riskEstimationNum2 }}</td>
                            <td class="text-center" style="width:110px;">{{ getRiskLevel(row) }}</td>
                          </tr>
                        </template>
                      </v-simple-table>
                    </v-col>
                    <v-col cols="6" class="pl-1">
                      <v-simple-table v-if="dataSetList[0].riskEstimation" class="custom-table">
                        <template
                          v-if="dataSetList[0].riskEstimation === '00002' && dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation]"
                        >
                          <tr class="text-center tableTitle">
                            <td colspan="3">개선 후 위험성 수준</td>
                          </tr>
                          <tr>
                            <td class="text-center tableTitle">{{ getHeaderValue('high') }}</td>
                            <td class="text-center tableTitle">{{ getHeaderValue('middle') }}</td>
                            <td class="text-center tableTitle">{{ getHeaderValue('lower') }}</td>
                          </tr>
                          <tr :key="tableComponentKey">
                            <td>
                              <v-radio-group
                                v-model="row.riskEstimationAfterVal1"
                                row
                                style="display:flex; justify-content:center !important;"
                              >
                                <v-radio
                                  color="radio"
                                  v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[0].minorCd"
                                  style="margin-left: 16px !important;"
                                  disabled
                                ></v-radio>
                              </v-radio-group>
                            </td>
                            <td>
                              <v-radio-group
                                v-model="row.riskEstimationAfterVal1"
                                row
                                style="display:flex; justify-content:center !important;"
                              >
                                <v-radio
                                  color="radio"
                                  v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[1].minorCd"
                                  style="margin-left: 16px !important;"
                                  disabled
                                ></v-radio>
                              </v-radio-group>
                            </td>
                            <td>
                              <v-radio-group
                                v-model="row.riskEstimationAfterVal1"
                                row
                                style="display:flex; justify-content:center !important;"
                              >
                                <v-radio
                                  color="radio"
                                  v-model="dataSetList[0].riskEstimationSetting[dataSetList[0].riskEstimation].data[2].minorCd"
                                  style="margin-left: 16px !important;"
                                  disabled
                                ></v-radio>
                              </v-radio-group>
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr class="text-center tableTitle">
                            <td colspan="3">개선 후 위험성 수준</td>
                          </tr>
                          <tr>
                            <td class="text-center tableTitle required">빈도</td>
                            <td class="text-center tableTitle required">강도</td>
                            <td class="text-center tableTitle">위험성</td>
                          </tr>
                          <tr :key="tableComponentKey">
                            <td class="text-center">{{ row.riskEstimationAfterNum1 }}</td>
                            <td class="text-center">{{ row.riskEstimationAfterNum2 }}</td>
                            <td
                              class="text-center"
                              style="width:110px;"
                            >{{ getRiskAfterLevel(row) }}</td>
                          </tr>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- <v-row no-gutters class="mt-5">
                <v-col cols="12">
                  <span class="editor-label">현재의 안전보건조치</span>
                  <v-text-field v-model="row.currentShMeasures" solo class="editor_bg" readonly></v-text-field>
                </v-col>
              </v-row>-->

              <v-divider class="mt-5" />
              <!-- 근로자 의견 -->
              <v-row no-gutters class="mt-5">
                <v-col cols="12">
                  <expansionPanelList
                    v-if="row.comments"
                    :subTitle="`근로자 의견 (${row.comments ? row.comments.length : 0})`"
                    :datasource="row.comments"
                  />
                </v-col>
              </v-row>
              <v-divider class="mt-5" />
              <p class="editor-title mt-5">조치(이행) 여부</p>

              <v-simple-table class="custom-table">
                <template>
                  <tr>
                    <td class="text-center tableTitle">조치(이행) 여부</td>
                    <td class="d-flex text-center tableTitle" style="width:100% !important;">
                      <div class="d-flex align-center">
                        <v-checkbox
                          v-model="row.impleYn"
                          class="pa-1"
                          :true-value="'Y'"
                          :false-value="'N'"
                          hide-details
                          disabled
                        ></v-checkbox>
                        <p class="mt-3">조치(이행) 완료</p>
                      </div>
                      <div class="d-flex align-center">
                        <v-checkbox
                          v-model="row.actYn"
                          class="pa-1"
                          hide-details
                          :true-value="'Y'"
                          :false-value="'N'"
                          disabled
                        ></v-checkbox>
                        <p class="mt-3">현장조치</p>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-center tableTitle" style="width: 30%">현장조치(이행) 내용</td>
                    <td>
                      <v-text-field
                        v-model="row.siteContent"
                        solo
                        hide-details="auto"
                        placeholder="이행 내용 또는 현장조치 내용을 입력하세요."
                        spellcheck="false"
                        @input="checkSiteContent(row)"
                      />
                    </td>
                  </tr>
                </template>
              </v-simple-table>

              <v-divider class="mt-5" />

              <p class="editor-title mt-5">감소대책</p>
              <!-- 감소대책 -->
              <v-card
                v-for="(item, indexRed) in row.reduction"
                :key="indexRed"
                width="100%"
                class="addable-card d-flex mt-4 pa-0"
              >
                <v-card width="100%" class="pa-4 addable-contents">
                  <v-row no-gutters>
                    <v-col v-if="item.__updated__" cols="12" class="d-flex align-center">
                      <span class="pl-2">수정중인 항목</span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="6" class="pr-2">
                      <span class="editor-label">감소대책</span>
                      <v-text-field
                        solo
                        class="editor_bg"
                        no-resize
                        auto-grow
                        readonly
                        v-model="item.riskReduceMeasuresContent"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pl-2">
                      <span class="editor-label">담당자</span>
                      <div class="mt-2">
                        <v-tooltip
                          bottom
                          v-for="(idx, indexPer) in item.person"
                          :key="`${idx.esgHrNo}_${indexPer}_${tableComponentKey}`"
                        >
                          <template v-slot:activator="{ on }">
                            <v-chip v-on="on" class="mr-2">
                              <v-icon left>mdi-account</v-icon>
                              {{ idx.korNm }}
                            </v-chip>
                          </template>
                          <div v-html="idx.grpAuthNm"></div>
                        </v-tooltip>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row no-gutters class="mt-5">
                    <v-col cols="6" class="pr-2">
                      <span class="editor-label">개선 예정일</span>

                      <v-text-field
                        :value="formatDate(item.planDt)"
                        append-icon="mdi-calendar"
                        readonly
                        solo
                        class="editor_bg"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pl-2">
                      <span class="editor-label required">개선 완료일</span>
                      <v-menu
                        :ref="'menuStDate_' + indexRed"
                        v-model="item.menuStDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        :min-width="100"
                        :disabled="readonly"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="formatDate(item.actDt)"
                            append-icon="mdi-calendar"
                            :readonly="readonly"
                            v-bind="attrs"
                            v-on="on"
                            solo
                            :rules="rules"
                            class="editor_bg"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="item.actDt"
                          no-title
                          scrollable
                          @input="item.menuStDate = false"
                          @change="updateItem(item)"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <!-- 개선자 -->
                  <v-simple-table class="mt-5 custom-table">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td class="text-center tableTitle required" style="width: 15%">개선자</td>
                          <td>
                            <v-tooltip
                              bottom
                              v-if="item.esgHrNo"
                              :key="`${item.esgHrNo}_${indexRed}_${tableComponentKey}`"
                            >
                              <template v-slot:activator="{ on }">
                                <v-chip v-if="readonly" v-on="on" class="mr-2 my-1">
                                  <v-icon left>mdi-account</v-icon>
                                  {{ item.korNm }}
                                </v-chip>
                                <v-chip
                                  v-else
                                  v-on="on"
                                  class="mr-2 my-1"
                                  close
                                  @click:close="chipClose(index, indexRed)"
                                >
                                  <v-icon left>mdi-account</v-icon>
                                  {{ item.korNm }}
                                </v-chip>
                              </template>
                              <div v-html="item.grpAuthNm"></div>
                            </v-tooltip>
                            <v-btn
                              v-if="!readonly"
                              x-small
                              class="pa-0 float-right my-2"
                              icon
                              @click="hrInfoPopupOpen(index, indexRed)"
                            >
                              <svg-icon style="height:18px; color:#9BA4AC;" icon-class="search"></svg-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <v-row no-gutters class="mt-5">
                    <v-col cols="12">
                      <span class="editor-label required">개선 조치 내용</span>
                      <v-textarea
                        solo
                        :rules="rules"
                        class="editor_bg"
                        clearable
                        no-resize
                        auto-grow
                        spellcheck="false"
                        clear-icon="mdi-close-circle-outline"
                        rows="3"
                        row-height="30"
                        :placeholder="getPlaceHolder('개선 조치내용을 작성 해 주세요.')"
                        v-model="item.actContent"
                        :disabled="readonly"
                        @input="updateItem(item)"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="mt-5">
                    <v-col cols="12">
                      <span class="editor-label">개선 조치</span>
                      <!-- 주요인적지적사항 -->
                      <v-simple-table class="custom-table">
                        <template v-slot:default>
                          <tbody v-if="item">
                            <tr>
                              <td class="tableTitle text-center" style="width: 50%;">전</td>
                              <td class="tableTitle text-center" style="width: 50%;">후</td>
                            </tr>
                            <tr style="height: 100px;">
                              <td
                                class="text-center"
                                v-for="(c, indexC) in item.code"
                                :key="indexC"
                              >
                                <iImgCellFileManage
                                  ref="imgCellFileManage"
                                  :created="c.target"
                                  :targetId="c.extra1"
                                  :fileExtension="allowedFileExtensions.join(', ')"
                                  targetType="00017"
                                  :readonly="readonly"
                                  @updateItem="updateItem(item)"
                                  @onImgCellFileChanged="onImgCellFileChanged($event)"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                  <!--div class="d-flex justify-end mt-5">
                    <v-btn elevation="0" text color="error" @click="initializedImplementation(item)" class="btn-underline ">이행 초기화</v-btn>
                  </div-->
                  <hrSelect
                    :id="personInfo"
                    :popupVisible="hrInfoPopupVisible"
                    @popupClose="hrInfoPopupVisible = false"
                    title="담당자 설정"
                    :company="item.clntId"
                    :selectedHrs="personList"
                    @apply="apply"
                    :mode="'single'"
                  />
                </v-card>
              </v-card>
              <div
                v-if="row.reduction.length === 0"
                class="grey--text text-center my-5 mx-auto"
              >감소대책이 없습니다.</div>
            </v-form>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <h3 v-else class="grey--text d-flex justify-center my-16">작성한 위험성평가 데이터가 없습니다.</h3>
</template>

<script>
// utils
import { getCurrentDate } from '@/utils/common.js'
import { getCommonCode } from '@/api/common/commonApi'
//컴포넌트
import hrSelect from '@/components/common/hrSelect.vue'
import iImgCellFileManage from '@/components/esgCommon/iImgCellFileManage'
import expansionPanelList from '@/components/esgCommon/expansionPanelList.vue'
export default {
  components: {
    hrSelect,
    expansionPanelList,
    iImgCellFileManage
  },
  name: 'implementationPanelTree',
  props: {
    assessmentKey: {
      type: Number,
      default: 0
    },
    datasource: {
      type: Array,
      default: () => []
    },
    dataSetList: {
      type: Array,
      default: () => []
    },
    deleteFileList: {
      type: Array,
      default: () => []
    },

    headerDefaultColor: {
      type: String,
      default: '#fff'
    },
    headerExpandedColor: {
      type: String,
      default: '#fff'
    },
    mainStyle: {
      type: String,
      default: 'font-size: 1rem; font-weight: 600'
    },
    sub1Style: {
      type: String,
      default: 'font-size: 1rem; font-weight: 400;'
    },
    sub2Style: {
      type: String,
      default: 'font-size: 1rem; font-weight: 400'
    },
    textStyle: {
      type: String,
      default: 'font-size: medium;'
    },
    divStyle: {
      type: String,
      default: ''
    },
    firstDataExpand: {
      type: Boolean,
      default: false
    },
    searchProcess: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: [
        value => {
          if (value) return true
          return '필수입력 값입니다.'
        }
      ],
      hrInfoPopupVisible: false,
      expandedPanel: [],
      test: false,
      titleColorList: [],
      //위험성 추정 기준
      color: 'grey',
      radioData: 'middle',
      deletList: [],
      personList: [],
      tableComponentKey: 0,
      personInfo: '',
      menuStDate: false,
      allowedFileExtensions: ['.jpg', '.jpeg', '.gif', '.png'],
      riskValueGroup: []
    }
  },
  watch: {
    datasource() {
      this.titleColorList = []
      this.datasource.forEach(row => {
        let defaultColor = {
          color: this.headerDefaultColor
        }
        this.titleColorList.push(defaultColor)
      })
      //패널 초기화
      if (this.assessmentKey || this.assessmentKey == 0) {
        // let index = this.datasource.findIndex(element => element.processId == this.searchProcess)
        let index = this.assessmentKey
        this.expandedPanel = index

        if (this.titleColorList[index]) {
          this.titleColorList[index].color = this.headerExpandedColor
        } else {
          this.titleColorList[index] = { color: this.headerExpandedColor }
        }
      }

      //현재날짜 세팅
      this.datasource.forEach(row => {
        // row.menuStDate가 비어 있는 경우 현재 날짜를 할당
        if (row.riskEstimationVal1 && !row.riskEstimationAfterVal1) {
          row.riskEstimationAfterVal1 = row.riskEstimationVal1
          row.riskEstimationAfterNum1 = row.riskEstimationNum1
        }
        if (row.riskEstimationVal2 && !row.riskEstimationAfterVal2) {
          row.riskEstimationAfterVal2 = row.riskEstimationVal2
          row.riskEstimationAfterNum2 = row.riskEstimationNum2
        }
        if (row.reduction.length > 0) {
          row.reduction.forEach(el => {
            if (!el.actDt) {
              el.actDt = getCurrentDate()
            }
          })
        }
      })
    }
  },
  computed: {
    mobileTrigger: function() {
      return this.width < 800
    }
  },
  beforeMount() {
    Promise.all([getCommonCode('RA002_1')]).then(response => {
      this.riskValueGroup = response[0].list
    })
  },
  mounted() {
    this.datasource.forEach((row, i) => {
      let defaultColor = {
        color: i == 0 && this.firstDataExpand ? this.headerExpandedColor : this.headerDefaultColor
      }
      this.titleColorList.push(defaultColor)
    })

    if (this.firstDataExpand) {
      this.expandedPanel = [0]
    }
  },
  methods: {
    checkSiteContent(data) {
      console.log('data', data)
      if (data.siteContent) {
        //현장조치(이행) 내용 있으면 'Y'
        data.actYn = 'Y'
      } else {
        data.actYn = ''
      }
    },
    chipClose(index, indexRed) {
      this.datasource[index].reduction[indexRed].esgHrNo = ''
      this.tableComponentKey++
      this.updateItem(this.datasource[index].reduction[indexRed])
    },
    getRiskLevel(item) {
      if (this.dataSetList[0].freqValueList.length > 0) {
        let data = this.dataSetList[0].freqValueList.find(el => el.minorCd == item.riskEstimationNum1 * item.riskEstimationNum2)
        return data ? data.minorNm : ''
      }
      return ''
    },
    getRiskAfterLevel(item) {
      if (this.dataSetList[0].freqValueList.length > 0) {
        let data = this.dataSetList[0].freqValueList.find(el => el.minorCd == item.riskEstimationAfterNum1 * item.riskEstimationAfterNum2)
        return data ? data.minorNm : ''
      }
      return ''
    },
    hrInfoPopupOpen(index, indexRed) {
      let item = this.datasource[index].reduction[indexRed]
      this.personInfo = index + '_' + indexRed + '_' + item.workId + '_' + item.riskFactorId + '_' + item.riskReduceMeasuresId
      this.personList = [item]
      this.hrInfoPopupVisible = true
    },
    apply(e) {
      const [index, indexRed, workId, riskFactorId, riskReduceMeasuresId] = this.personInfo.split('_')
      let data = {
        index: index,
        indexRed: indexRed,
        workId: workId,
        riskFactorId: riskFactorId,
        riskReduceMeasuresId: riskReduceMeasuresId
      }

      if (this.datasource[data.index].reduction && this.datasource[data.index].reduction.length > 0) {
        this.datasource[data.index].reduction[indexRed].esgHrNo = e.esgHrNo
        this.datasource[data.index].reduction[indexRed].korNm = e.korNm
        this.datasource[data.index].reduction[indexRed].grpAuthNm = e.grpAuthNm
      }
      this.hrInfoPopupVisible = false
      this.tableComponentKey++
      this.updateItem(this.datasource[data.index].reduction[indexRed])
    },
    riskEstimationChanged() {
      // 허용가능한 위험성 기준 값 변경
      if (this.dataSetList[0].riskEstimation === '00002') {
        this.datasource.riskEstimationAfterVal1 = 'f_3'
        this.datasource.riskEstimationAfterVal1 = 's_3'
      } else if (this.dataSetList[0].riskEstimation === '00001') {
        this.datasource.riskEstimationAfterVal1 = 'middle'
      }
    },
    titleClick(index) {
      if (this.titleColorList[index].color === this.headerDefaultColor) {
        this.titleColorList[index].color = this.headerExpandedColor
        this.titleColorList.forEach(element => {
          if (element != this.titleColorList[index]) element.color = this.headerDefaultColor
        })
      } else {
        this.titleColorList[index].color = this.headerDefaultColor
      }
      this.$emit('titleClick', index)
    },
    ///////////////////////////////////////
    /*               Event               */
    ///////////////////////////////////////
    formatDate(date) {
      if (!date) return null

      if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      } else {
        return date
      }
    },
    getHeaderValue(code) {
      if (!this.riskValueGroup.length) {
        Promise.all([getCommonCode('RA002_1')]).then(response => {
          this.riskValueGroup = response[0].list
        })
      } else {
        let data = this.riskValueGroup.find(element => element.minorCd == code)
        let text = `${data.minorNm}(${data.extra3})`
        return text
      }
    },
    getPlaceHolder(content) {
      let placeholder = this.readonly ? '' : content
      return placeholder
    },
    initializedImplementation(item) {
      this.$emit('initializedImplementation', item)
    },
    updateItem(row) {
      if (!row.__updated__) row.__updated__ = true
      this.$forceUpdate()
    },
    onImgCellFileChanged(e) {
      console.log('####### e', e)
      if (e.type === 'remove') {
        let deleteFile = {
          targetType: '00017',
          targetId: e.targetId
        }
        this.deleteFileList.push(deleteFile)
      }
    }
  }
}
</script>
<style scoped>
.tg {
  margin: 10px 0;
  border-collapse: collapse;
  border-spacing: 0;
}
.tg td {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  padding: 10px 5px;
  word-break: normal;
}
.tg th {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  padding: 10px 5px;
  word-break: normal;
}
.tg .tableBk {
  background-color: #f4f5f6;
  text-align: center;
  text-align: bold;
  vertical-align: top;
}
.tg .tg-0pky {
  border-color: inherit;
  text-align: left;
  vertical-align: top;
}
</style>
